//#region Imports

import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconComponent } from '../icon/icon.component';
import { Course } from '../../models/interfaces/course.interface';
import { ButtonComponent } from "../button/button.component";
import { ButtonTypeEnum } from '../button/types/button-type.enum';
import { ButtonRadiusEnum } from '../button/types/button-radius.enum';
import { CourseCardState } from '../../models/enums/course-card-state.enum';
import { CourseLocation } from '../../models/enums/course-location.enum';
import { COURSE_LOCATION_ICONS, COURSE_LOCATION_LABELS } from '../../models/records/course-location.record';

//#endregion

@Component({
  selector: 'l-course-card',
  standalone: true,
  imports: [IconComponent, ButtonComponent, RouterLink],
  templateUrl: './course-card.component.html'
})
export class CourseCardComponent {

  //#region Public Properties

  @Input({ required: true }) 
  public course!: Course;

  public buttonTypeEnum: typeof ButtonTypeEnum = ButtonTypeEnum;

  public buttonRadiusEnum: typeof ButtonRadiusEnum = ButtonRadiusEnum;

  public courseCardState: typeof CourseCardState = CourseCardState;

  public get state(): CourseCardState {
    const progress = this.progress;
    if (progress >= 100) return CourseCardState.COMPLETED;
    if (progress > 0) return CourseCardState.IN_PROGRESS;
    return CourseCardState.BASIC;
  }

  public get progress(): number {
    return Math.min(100, Math.max(0, this.course.progress ?? 0));
  }

  public get courseLocationLabel(): string {
    return COURSE_LOCATION_LABELS[this.course.location ?? CourseLocation.ONLINE];
  }

  public get courseLocationIcon(): string {
    return COURSE_LOCATION_ICONS[this.course.location ?? CourseLocation.ONLINE];
  }

  public get modulesCountLabel(): string {
    const count = this.course.modulesIds?.length ?? 0;
    return `${count} ${count === 1 ? 'módulo' : 'módulos'}`;
  }

  public get durationLabel(): string {
    const hours = (this.course.durationMinutes ?? 0) / 60;
    const formatted = Number.isInteger(hours) ? hours.toString() : hours.toFixed(1).replace(/\.0$/, '');
    return `${formatted}h`;
  }

  public get showProgress(): boolean {
    return this.state !== CourseCardState.BASIC;
  }

  public get showDescription(): boolean {
    return this.state === CourseCardState.BASIC;
  }

  public get secondaryCtaLabel(): string {
    return this.state === CourseCardState.COMPLETED ? 'Download certificado' : 'Continue aprendendo';
  }

  public get secondaryCtaRoute(): string[] | null {
    if (!this.course?.id || this.state === CourseCardState.COMPLETED) return null;

    return ['/courses', this.course.id, 'content'];
  }

  public get courseDetailsRoute(): string[] | null {
    if (!this.course?.id) return null;

    return ['/courses', this.course.id];
  }

  public get progressBarWidth(): string {
    return `${this.progress}%`;
  }

  //#endregion
  
}
